export const profilePaths = {
  base: 'profile',
  residencyInformation: 'residencyInformations',
  familyInformation: 'familyInformation',
  academyInformation: 'academyInformation',
};

export const profileRoutes = {
  profile: `/${profilePaths.base}`,
  residencyInformation: `/${profilePaths.base}/${profilePaths.residencyInformation}`,
  familyInformation: `/${profilePaths.base}/${profilePaths.familyInformation}`,
  academyInformation: `/${profilePaths.base}/${profilePaths.academyInformation}`,
};
